import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './GlobalLoginModal.css';

const GlobalLoginModal = () => {
    const { showLoginModal, login } = useAuth();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [pinCode, setPinCode] = useState('');
    const [error, setError] = useState('');
    // Use relative path for proxy
    const BASE_URL = '';

    if (!showLoginModal) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const response = await fetch(`${BASE_URL}/api/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                // 서버가 읽는 필드 이름은 `pin` 이다(auth.controller). 여기서 `pinCode` 로
                // 보내고 있어서 `req.pin` 이 늘 undefined 였고, **어떤 PIN 을 넣어도
                // 반드시 실패**했다. 정상 로그인 화면은 `pin` 을 보내 멀쩡했기 때문에
                // 세션 만료 때만 재로그인이 안 되는 것으로 보였다.
                body: JSON.stringify({ username, password, pin: pinCode }),
            });

            if (!response.ok) {
                // 서버는 '자격 증명'과 'PIN'을 구분해서 알려 준다. 뭉뚱그려 보여 주면
                // 무엇을 고쳐야 할지 알 수 없다 — 위 버그가 오래 안 보인 이유이기도 하다.
                const body = await response.json().catch(() => ({}));
                throw new Error(
                    body.message === 'Invalid PIN code'
                        ? 'PIN 번호가 올바르지 않습니다.'
                        : body.message === 'Invalid credentials'
                            ? '아이디 또는 비밀번호가 올바르지 않습니다.'
                            : '로그인에 실패했습니다.',
                );
            }

            const data = await response.json();
            // Login function in Context will close modal and trigger 'loginSuccess' event
            login(data.access_token, username);

            // Clear fields for next time
            setUsername('');
            setPassword('');
            setPinCode('');
        } catch (err) {
            console.error(err);
            setError(err.message || '로그인에 실패했습니다.');
        }
    };

    return (
        <div className="global-login-modal-overlay">
            <div className="global-login-modal-content">
                <h2 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>세션 만료 (로그인)</h2>
                <p style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#666', fontSize: '0.9rem' }}>
                    작업을 계속하시려면 다시 로그인해주세요.<br />진행 중인 내용은 유지됩니다.
                </p>
                {error && <div style={{ color: 'red', marginBottom: '1rem', textAlign: 'center' }}>{error}</div>}
                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '1rem' }}>
                        <input
                            type="text"
                            placeholder="아이디"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            autoComplete="username"
                            style={{ width: '100%', padding: '0.6rem', border: '1px solid #ddd', borderRadius: '4px' }}
                            required
                        />
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <input
                            type="password"
                            placeholder="비밀번호"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                            style={{ width: '100%', padding: '0.6rem', border: '1px solid #ddd', borderRadius: '4px' }}
                            required
                        />
                    </div>
                    <div style={{ marginBottom: '1.5rem' }}>
                        <input
                            type="password"
                            placeholder="PIN 코드 (6자리)"
                            value={pinCode}
                            onChange={(e) => setPinCode(e.target.value)}
                            maxLength={6}
                            style={{ width: '100%', padding: '0.6rem', border: '1px solid #ddd', borderRadius: '4px' }}
                            required
                        />
                    </div>
                    <button type="submit" style={{ width: '100%', padding: '0.75rem', backgroundColor: '#333', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
                        로그인 및 계속하기
                    </button>
                </form>
            </div>
        </div>
    );
};

export default GlobalLoginModal;
